<ng-container *ngIf="recordSearchResults">
  <app-esri-map
    class="full"
    [displayLocationTypeCheckBoxes]="false"
    [birdLocations]="recordSearchResults"
    [selectedIslandName]="firstIslandSearchResult"
  ></app-esri-map>
</ng-container>
